<template>
  <section class="EmployeesModal">
    <div
      class="pb-5"
    >
      <h2
        :class="[
          'font-semibold',
          'font-xl',
        ]"
      >
        Add New Employees
      </h2>
    </div>

    <div
      class="pb-5"
    >
      Enter employee's emails separated by , to send a bundel invitation.
    </div>

    <div
      class="EmployeesModal__textareaContainer"
    >
      <textarea
        :value="employeesModuleEmails"
        :class="[
          'font-m',
          'color-ink-light'
        ]"
        :disabled="employeesModuleStatus.SEND_IN"
        rows="8"
        cols="50"
        class="EmployeesModal__textarea w-100"
        placeholder="Please add employees emails ..."
        @keyup.stop="updateEmployeesEmails({ employeesEmails: $event.target.value})"
      />
    </div>

    <MuiCardAlert
      v-if="employeesModuleStatus.FORM_VALID"
      :full-width="true"
      type="success"
      class="mt-5"
    >
      The emails are valid, please SEND
    </MuiCardAlert>

    <MuiCardAlert
      v-if="employeesModuleStatus.FORM_INVALID"
      :full-width="true"
      type="alert"
      class="mt-5"
    >
      The emails are invalid, you can't SEND
    </MuiCardAlert>

    <MuiCardAlert
      v-if="employeesModuleStatus.SEND_IN"
      :full-width="true"
      type="info"
      class="mt-5"
    >
      Sending emails to the server, please wait.
    </MuiCardAlert>

    <MuiCardAlert
      v-if="employeesModuleStatus.SEND_ERROR"
      :full-width="true"
      type="danger"
      class="mt-5"
    >
      There was a problem with the last SEND.
    </MuiCardAlert>
  </section>
</template>

<script>

import {
  mapState,
  mapActions,
} from 'vuex';

// Motion UI Components
import { MuiCardAlert } from '@ubeeqo/motion-ui';

// Local Stores
import * as EmployeesModule from '../EmployeesModule';

export default {
  name: 'EmployeesModalComponent',
  components: {
    MuiCardAlert,
  },
  computed: {
    ...mapState(EmployeesModule.FULL_NAMESPACE, {
      employeesModuleEmails: state => state.employeesEmails,
      employeesModuleStatus: state => state.STATUS,
    }),
  },
  methods: {
    ...mapActions(`${EmployeesModule.FULL_NAMESPACE}`, {
      updateEmployeesEmails: 'updateEmployeesEmails',
    }),
  },
};
</script>
